import React, { Component } from 'react';
import {InfoBar} from './info-bar.js';
import './footer.css';
import iconContact from './resource/contact.svg';
import iconHelp from './resource/help.svg';

export class Footer extends Component {

   render () {

        return ( 
            <div className="footer">
             <div className="content" id="contentId">
               
                <div className="footerTile" id="footerTile">
                    
                            <div className="footerTileDownOneTile">
                                
                                <img src={iconHelp} alt="Hilfe" /><br/>
                                <div className="footerHeaderText">Benötigen Sie Hilfe
                                                                    oder Informationen?
                                    
                                </div>
                                
                                <div className="footerContentText"> 
                                  <InfoBar faq={this.props.faqs}></InfoBar>
                                </div>
                            
                            </div>
                        
                            <div className="footerTileDownOneTile footerTileDownOneTileRight">

                                  <img src={iconContact} alt="Kontakt" /><br />
                                  <div className="footerHeaderText">Kontakt</div>

                                  <div className="footerContentText">
                                    <span className="Bold">F&nbsp;</span> +49 211-54 76 16 01 <br />
                                    <span className="Bold">M&nbsp;</span> Kontakt@ayacandas.com <br />
                                    <span className="Bold">T&nbsp;</span> +49 211 54 76 16 0 <br />
                                    <div className="button marginTop10"><a className="toContactFormText" href={`/contact/#contactform`} >Zum Kontaktformular</a></div> <br />
                                    <div className="marginTop10"><a className="toContactFormText" href={`/contact/#contactId`}> Über Ayacandas & Impressum </a></div><br />
                                    <br />
                                  </div>
                            
                            </div> 
                            
                         </div>
                    </div>
                </div>
            );
        }
    }



// WEBPACK FOOTER //
// ./src/footer.js